// Lib
import React from 'react';
import PropTypes from 'prop-types';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';

// Components
import Icon from '../../components/icons/Icon';

// Styles
import './TaskDeleteButton.scss';

class TaskDeleteButton extends React.Component {
    moveToTrash = (event) => {
        event.stopPropagation();
        event.preventDefault();

        const { elementId, moveToTrashHandler } = this.props;

        return moveToTrashHandler({ elementId });
    };

    render() {
        const { show } = this.props;

        const component = show ? (
            <div className="TaskDeleteButton" onMouseDown={this.moveToTrash}>
                <div className="background" />
                <Icon name="task-trash" />
            </div>
        ) : null;

        return (
            <div className="delete-button-container">
                <CSSTransitionGroup
                    transitionName="slide"
                    transitionAppear
                    transitionAppearTimeout={200}
                    transitionEnterTimeout={200}
                    transitionLeaveTimeout={200}
                >
                    {component}
                </CSSTransitionGroup>
            </div>
        );
    }
}

TaskDeleteButton.propTypes = {
    show: PropTypes.bool,
    elementId: PropTypes.string.isRequired,

    moveToTrashHandler: PropTypes.func,
};

export default TaskDeleteButton;
